export interface Opdracht {
    klantnummer: string;
    info: string;
    documenten: UploadDocument[];
    opdracht_status: OpdrachtStatus;
}

export enum UploadDocumentFoutProcess {
    CONVERTEREN = 'converteren',
    ANONIMISEREN = 'anonimiseren',
    UPLOADEN = 'uploaden'
}

export interface UploadDocumentFout {
    melding: string;
    bestandsnaam: string;
    proces: UploadDocumentFoutProcess;
}

export interface UploadDocument {
    opdracht_id: string;
    document_id: string;
    naam: string;
    upload_status: UploadStatus;
    referentie: string;
    maximum_grootte: number;
    toegestane_formaten: FileType[];
    doel_bestandsformaat: TargetFileType;
    doel_omgeving: DoelOmgeving;
    multi_upload: boolean;
    document_soorten: DocumentSoort[];
    bestandsnamen: string[];
    fout?: UploadDocumentFout;
}

export enum OpdrachtStatus {
    AANGEMELD = 'aangemeld',
    COMPLEET = 'compleet',
    VERLOPEN = 'verlopen',
    HEROPEND = 'heropend',
    AFGEROND = 'afgerond'
}

export enum UploadStatus {
    AANGEMELD = 'aangemeld',
    IN_UITVOERING = 'in_uitvoering',
    GEREED = 'gereed',
    MISLUKT = 'mislukt',
    GEANNULEERD = 'geannuleerd',
    AFGEROND = 'afgerond',
    AFGEKEURD = 'afgekeurd'
}

export enum UploadStatusPatch {
    AFGEROND = 'afgerond',
    AFGEKEURD = 'afgekeurd'
}

export enum DocumentSoort {
    JAAROVERZICHT = 'Jaaroverzicht',
    VOORWAARDEN = 'Voorwaarden',
    CONTRACT = 'Contract',
    UPLOADS = 'Uploads',
    RENTE_EN_KOSTENOVERZICHT = 'Rente- en kostenoverzicht',
    ADVIESRAPPORT = 'Adviesrapport',
    UITKERINGSSPECIFICATIE = 'Uitkeringsspecificatie',
    NOTA = 'Nota'
}

export enum DocumentGroep {
    JAAROVERZICHT = 'Jaaroverzicht',
    VOORWAARDEN = 'Voorwaarden',
    CONTRACT = 'Contract',
    UPLOADS = 'Uploads',
    RENTE_EN_KOSTENOVERZICHT = 'Rente- en kostenoverzicht',
    ADVIESRAPPORT = 'Adviesrapport',
    UITKERINGSSPECIFICATIE = 'Uitkeringsspecificatie',
    NOTA = 'Nota'
}

export enum ProductGroep {
    ALGEMEEN = 'Algemeen',
    BETALEN = 'Betalen',
    SPAREN = 'Sparen',
    PENSIOENEN = 'Pensioenen',
    BELEGGEN = 'Beleggen',
    HYPOTHEKEN = 'Hypotheken',
    VERZEKERINGEN = 'Verzekeringen',
    LENEN = 'Lenen'
}

export enum FileType {
    PDF = 'pdf',
    JPG = 'jpg',
    PNG = 'png',
    GIF = 'gif',
    BMP = 'bmp',
    DOC = 'doc',
    DOCX = 'docx'
}

export enum TargetFileType {
    PDF = 'pdf',
    TRUSTED_PDF = 'trusted_pdf',
    TIFF = 'tiff',
    PDF_MET_ORIGINEEL = 'pdf_met_origineel',
    NIET_CONVERTEREN = 'niet_converteren'
}

export enum DoelOmgevingsType {
    SHAREPOINT = 'sharepoint',
    DIGITALE_KLUIS = 'digitale_kluis',
    ARCHIEF = 'archief'
}

export interface DoelOmgeving {
    doelomgevingstype: DoelOmgevingsType;
    document_data?: string;
}

export interface DigitaleKluis extends DoelOmgeving {
    documentgroep: DocumentGroep;
    productgroepen: ProductGroep;
}

export interface Sharepoint extends DoelOmgeving {
    site_id: string;
    repo_id: string;
    folder_name: string;
}

// eslint-disable-next-line
export interface Archief extends DoelOmgeving {}
